"use client";
const OmossButtonRightArrow = ({ width = 34, height = 35, className = "" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.998 34.5005C26.3869 34.5005 33.998 26.8893 33.998 17.5005C33.998 8.11165 26.3869 0.500488 16.998 0.500488C7.60921 0.500488 -0.00195319 8.11165 -0.00195327 17.5005C-0.00195334 26.8893 7.60921 34.5005 16.998 34.5005Z"
        fill="#5C2483"
      />
      <path
        d="M26.5179 15.1556L19.4869 8.12451L18.1411 9.47031L25.1721 16.5014C25.1871 16.5163 25.1994 16.5327 25.2143 16.5476L5.78809 16.5476L5.78809 18.4513L25.213 18.4513C25.1994 18.4663 25.1857 18.4826 25.1708 18.4976L18.1397 25.5287L19.4855 26.8745L26.5152 19.8434C27.1412 19.2174 27.4868 18.3847 27.4868 17.5002C27.4868 16.6157 27.1425 15.7829 26.5166 15.1556L26.5179 15.1556Z"
        fill="#CAE1D3"
      />
    </svg>
  );
};

export default OmossButtonRightArrow;
